export const CODE_TERM: Record<string, string> = {
  site_cso_: '#SITE_CSO#',
  site_email_: '#SITE_EMAIL#',
  site_name_: '#SITE_NAME#',
  site_tel_: '#SITE_TEL#',
};
